import type { AssetsBatchEditLocationProps } from "./assets-batch-edit-location.type";

import BatchEditForm from "@/modules/batch-edit-form";
import LocationSelectParent from "@/modules/location/location-select-parent";

import { useAssetsBatchEditLocation } from "./assets-batch-edit-location.hook";

export const AssetsBatchEditLocation = ({
  assets,
}: AssetsBatchEditLocationProps) => {
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useAssetsBatchEditLocation(assets);

  return (
    <BatchEditForm
      modelKey="asset"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
    >
      <LocationSelectParent
        name={fieldName}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      />
    </BatchEditForm>
  );
};
